import { apiService } from './api';
import type { Subject } from '../types';

export class SubjectService {
  private baseUrl = '/api/subjects';

  async getSubjects(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<{ subjects: Subject[]; totalCount: number; page: number; pageSize: number; totalPages: number }> {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.pageSize) searchParams.append('pageSize', params.pageSize.toString());
    if (params?.search) searchParams.append('search', params.search);

    const queryString = searchParams.toString();
    const endpoint = queryString ? `${this.baseUrl}?${queryString}` : this.baseUrl;
    
    const response = await apiService.get(endpoint);
    return response as { subjects: Subject[]; totalCount: number; page: number; pageSize: number; totalPages: number };
  }

  async getSubjectById(id: string): Promise<Subject> {
    return apiService.get<Subject>(`${this.baseUrl}/${id}`);
  }

  async createSubject(subjectData: { name: string; description?: string }): Promise<Subject> {
    return apiService.post<Subject>(this.baseUrl, subjectData);
  }

  async updateSubject(id: string, subjectData: { name: string; description?: string }): Promise<Subject> {
    return apiService.put<Subject>(`${this.baseUrl}/${id}`, subjectData);
  }

  async deleteSubject(id: string): Promise<void> {
    return apiService.delete<void>(`${this.baseUrl}/${id}`);
  }
}

export const subjectService = new SubjectService();

